var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getBasicImageObject = function (_a, representativeOfPage) {
    var height = _a.height, width = _a.width, alt = _a.alt, url = _a.url;
    if (representativeOfPage === void 0) { representativeOfPage = true; }
    return (__assign(__assign(__assign(__assign(__assign({ '@type': 'ImageObject' }, (height ? { height: String(height) } : {})), (width ? { width: String(width) } : {})), (alt ? { name: alt } : {})), (url ? { contentUrl: url } : {})), (representativeOfPage ? { representativeOfPage: true } : {})));
};
